import { seatAfter } from "../core/trick";
/** Decision 180: left, right, across, hold, and round again. */
export const PASS_CYCLE = ["left", "right", "across", "hold"];
export const PASS_COUNT = 3;
export const HEART_POINTS = 1;
export const QUEEN_POINTS = 13;
/** Every heart and the queen of spades: taking them all shoots the moon. */
export const MOON_POINTS = 26;
/** House rule (decision 183): the jack of diamonds takes ten off. */
export const JACK_BONUS = -10;
export const DEFAULT_GOAL = 100;
export const GOAL_OPTIONS = [50, 100];
export const DEFAULT_LENGTH = 4;
export const LENGTH_OPTIONS = [4, 8, 12];
export const GOAL_HAND_LIMIT = 99;
export class HeartsError extends Error {
    code;
    constructor(code) {
        super(code);
        this.name = "HeartsError";
        this.code = code;
    }
}
export function passDirection(hand) {
    return PASS_CYCLE[(hand - 1) % PASS_CYCLE.length] ?? "hold";
}
/**
 * The seat that receives this seat's cards. Play runs to the right here (seat + 1 sits on
 * your right), so "left" is three seats on.
 */
export function passTarget(seat, direction) {
    if (direction === "hold")
        return null;
    const steps = direction === "right" ? 1 : direction === "across" ? 2 : 3;
    return seatAfter(seat, steps);
}
/** Seats still choosing their three cards, in seat order. */
export function pendingPassers(state) {
    if (state.phase !== "passing")
        return [];
    return [0, 1, 2, 3].filter((seat) => state.passes[seat] === null);
}
/** Seat expected to play a card; null while passing, between tricks and after the hand. */
export function currentActor(state) {
    if (state.phase !== "playing" || state.trick.winner !== null)
        return null;
    return seatAfter(state.trick.leader, state.trick.plays.length);
}
//# sourceMappingURL=state.js.map